export default {
  BASE_URL: 'psm/gdp/admin',
  api: [
    {
      name: 'listForWaitCheck',
      desc: '待审核',
      method: 'GET',
      path: '/listForWaitCheck'
    },

    {
      name: 'listForCheckPass',
      desc: '获取已审核列表',
      method: 'GET',
      path: '/listForCheckPass'
    },
    {
      name: 'listForApproval',
      desc: '获取已立项列表',
      method: 'GET',
      path: '/listForApproval'
    },
    {
      name: 'listWaitAccept',
      desc: '获取待验收列表',
      method: 'GET',
      path: '/listWaitAccept'
    },{
      name: 'listAcceptSuccess',
      desc: '获取验收通过列表',
      method: 'GET',
      path: '/listAcceptSuccess'
    },
    {
      name: 'listWaitForCertifi',
      desc: '获取待发证列表',
      method: 'GET',
      path: '/listWaitForCertifi'
    },{
      name: 'listReject',
      desc: '获取待发证列表',
      method: 'GET',
      path: '/listReject'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'GET',
      path: '/remove'
    },
    {
      name: 'audit',
      desc: '审批',
      method: 'POST',
      path: '/audit'
    },
    {
      name: 'history',
      desc: '历史申报',
      method: 'GET',
      path: '/history'
    }
    ,{
      name: 'wait-cer',
     desc: '设置待发证',
     method: 'POST',
     path: '/auditForWaitCer'     
   },{
      name: 'auditForExit',
     desc: '退出确认',
     method: 'POST',
     path: '/auditForExit'     
   },{
    name: 'export',
    desc: '导出',
    method: 'POST',
    path: '/export'
  },
  {
    name:'declare-update',
    desc: '更新申报信息',
    method: 'POST',
    path: '/update'
  },
  {
    name: 'exportApproval',
    desc: '导出已立项列表',
    method: 'POST',
    path: '/exportApproval'
  },
  {
    name: 'exportWaitAccept',
    desc: '导出待验收列表',
    method: 'POST',
    path: '/exportWaitAccept'
  },
  {
    name:'exportExamine',
    desc:'导出已审核列表',
    method:'POST',
    path:'/exportExamine'
  }
  ]
}



// WEBPACK FOOTER //
// ./src/api/psm/gdp/admin.js